import { Outlet } from "react-router-dom";
import { CssBaseline } from "@mui/material";
import React from "react";
export function BaseLayout() {
  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
          overflowY: "hidden",
          marginTop: "64px",
        }}
      >
        <Outlet />
        <CssBaseline />
      </div>
    </>
  );
}
